<template>
  <div class="condition">
    <Header  :title="'各类课表查询'+this.tittleName" type="0" :route="this.$route.query.singcont==1?'/homeIndex':'/teacher/surfaAll'" />
    <div >
      <van-cell
        title="学年学期"
        is-link
        icon="label-o"
        @click="xnxqPop = true"
        :value="xnxq.mc"
      />
      <van-cell
        title="时间模式"
        is-link
        icon="label-o"
        @click="timePop = true"
        :value="timeMsVal.kbjcmsmc"
      />
     <van-field v-if="this.type=='0'"
        v-model="searchName"
        label="上课教师"
        readonly
        left-icon="label-o"
        input-align="right"
        placeholder="请点击选择"
        @click="alterTeacherPicker = true"
      />
	  <van-field v-if="this.type=='1'"
        v-model="searchName"
        label="上课班级"
        readonly
        left-icon="label-o"
        input-align="right"
        placeholder="请点击选择"
         @click="alterClassPicker = true"
      />
	  <van-field v-if="this.type=='2'"
        v-model="searchName"
        label="上课课程"
        readonly
        left-icon="label-o"
        input-align="right"
        placeholder="请点击选择"
        @click="alterCuraPicker = true"
      />
      <van-cell
        title="教学功能区"
        is-link
        icon="label-o"
        @click="jxgnqPop = true"
        :value="jxgnqVal.text" v-if="this.type=='3'"
      />
      <van-cell
        title="教学楼"
        is-link
        icon="label-o"
        @click="jxlPop = true"
        :value="jxlVal.text" v-if="this.type=='3'"
      />
	  <van-field v-if="this.type=='3'"
        v-model="searchName"
        label="上课教室"
        readonly
        left-icon="label-o"
        input-align="right"
        placeholder="请点击选择"
        @click="timer=Math.random()*100*Math.random();alterClassRoomPicker = true"
      />
    </div>
    <div class="btn">
      <van-button type="primary" block color="#7469F8" @click="search"
        >查询</van-button
      >
    </div>
    <!-- 学年学期 -->
    <van-popup v-model="xnxqPop" position="bottom">
      <van-picker
        :columns="xnxqList"
        :item-height="35"
        show-toolbar
        @cancel="xnxqPop = false"
        @confirm="xnxqConfirm"
      ></van-picker>
    </van-popup>
    <!-- 时间模式 -->
    <van-popup v-model="timePop" position="bottom">
      <van-picker
        :columns="timeList"
        :item-height="35"
        show-toolbar
        @cancel="timePop = false"
        @confirm="timeConfirm"
      ></van-picker>
    </van-popup>
    <!-- 教学功能区 -->
    <van-popup v-model="jxgnqPop" position="bottom">
      <van-picker
        :columns="jxgnqList"
        :item-height="35"
        show-toolbar
        @cancel="jxgnqPop = false"
        @confirm="gnqConfirm"
      ></van-picker>
    </van-popup>
    <!-- 教学楼 -->
    <van-popup v-model="jxlPop" position="bottom">
      <van-picker
        :columns="jxlList"
        :item-height="35"
        show-toolbar
        @cancel="jxlPop = false"
        @confirm="jxlConfirm"
      ></van-picker>
    </van-popup>
    <van-popup v-model="alterTeacherPicker" position="bottom" class="alter-pop">
      <alterTeacher @closePop="closePop" :isRadio="true"></alterTeacher>
    </van-popup>
     <van-popup v-model="alterClassPicker" position="bottom" class="alter-pop">
      <alterClass @closePop="closePop" :isRadio="true"></alterClass>
    </van-popup>
    <van-popup v-model="alterClassRoomPicker" position="bottom" class="alter-pop">
      <alterClassRoom @closePop="closePop" :isRadio="true" :jxgnqSelected="jxgnqVal.id" :jxlSelected="jxlVal.id" :key="timer"></alterClassRoom>
    </van-popup>
     <van-popup v-model="alterCuraPicker" position="bottom" class="alter-pop">
      <alterCura @closePop="closePop" :isRadio="true"></alterCura>
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
import alterTeacher from "../../common/teacherList";
import alterClass from "../../common/classList";
import alterClassRoom from "../../common/classRoomList";
import alterCura from "../../common/courseList";
export default {
  data() {
    return {
      type: this.$route.query.findType,
      xnxqPop: false,
      timePop: false,
      jxgnqPop:false,
      jxlPop:false,
      xnxqList: [],
      timeList:[],
      jxgnqList:[],
      jxlList:[],
      form: {
        xnxq: "",
      },
      xnxq: {},
      timeMsVal: {
        sjmsid:"",
        kbjcmsmc:"",
      },
      jxgnqVal:{
        id:'',
        text:'',
      },
      jxlVal:{
        id:'',
        text:'',
      },
      initTimeList:{},
      initXnxqList:{},
      initJxgnqList:{},
      initJxlList:{},
      alterTeacherPicker:false,
      alterClassPicker:false,
      alterCuraPicker:false,
      alterClassRoomPicker:false,
      searchVal:"",
      searchName: "",
      tittleName:"",
      timer:Math.random()*100*Math.random(),
    };
  },
  created() {
     this.searchVal = this.$route.query.searchVal;
     this.searchName = this.$route.query.searchName;
     if(this.$route.query.findType=='0'){
        this.tittleName = "（教师）";
      }else if(this.$route.query.findType=='1'){
        this.tittleName = "（班级）";
      }else if(this.$route.query.findType=='2'){
        this.tittleName = "（课程）";
      }else if(this.$route.query.findType=='3'){
        this.tittleName = "（教室）";
      }
    //初始化数据
    this.initData();
  },  
  components: {
    alterTeacher,
    alterClass,
    alterClassRoom,
    alterCura
  },
  methods: {
    //初始化数据
    async initData(){
      const params = {
          xnxq:'',
        }
       const res = await Api.initCurAllData(params);
       this.initTimeList = res.data.sjList;
       this.initXnxqList = res.data.xnxqList;
       this.setXnxq();
       this.setTimeObj();
       let paramsTc = {
        zzdtype:'TeachBud,TeachFuction',
      }
      const resTc = await Api.findDictionry(paramsTc);
      this.initJxgnqList = resTc.data.TeachFuction;
      this.initJxlList = resTc.data.TeachBud;
      this.setJxgnqObj();
      this.setJxlObj();
      
    },
    // 获取学年学期
    setXnxq() {
       for(let i=0;i<this.initXnxqList.length;i++){
         if(this.initXnxqList[i].isdqxq=='1'){
              this.xnxq = {
                dm: this.initXnxqList[i].xnxq01id,
                mc: this.initXnxqList[i].xqmc
              };
         }
         this.xnxqList.push({'value': this.initXnxqList[i].xnxq01id, 'text': this.initXnxqList[i].xqmc});
      }
    },
    setTimeObj() {
      for(let i=0;i<this.initTimeList.length;i++){
            this.timeList.push({'value': this.initTimeList[i].kbjcmsid, 'text': this.initTimeList[i].kbjcmsmc});
            if(this.initTimeList[i].mrms=='1'){
              this.timeMsVal ={
                  sjmsid:this.initTimeList[i].kbjcmsid,
                  kbjcmsmc:this.initTimeList[i].kbjcmsmc,
              } 
            }
		} 
    },
    setJxgnqObj(){
      for(let i=0;i<this.initJxgnqList.length;i++){
            this.jxgnqList.push({'value': this.initJxgnqList[i].gnqid, 'text': this.initJxgnqList[i].gnqmc});
            if(this.initJxgnqList[i].gnqmc=='主校区多媒体教室'){
              this.jxgnqVal ={
                  id:this.initJxgnqList[i].gnqid,
                  text:this.initJxgnqList[i].gnqmc,
              } 
            }
		} 
      
    },
    setJxlObj(){
      for(let i=0;i<this.initJxlList.length;i++){
            this.jxlList.push({'value': this.initJxlList[i].jzwid, 'text': this.initJxlList[i].jzwmc});
		} 
    },
    xnxqConfirm(value) {
      this.xnxq.mc = value.text;
      this.xnxq.dm = value.value;
      this.xnxqPop = false;
    },
    timeConfirm(e) {
      this.timeMsVal.sjmsid = e.value;
      this.timeMsVal.kbjcmsmc = e.text;
      this.timePop = false;
    },
    gnqConfirm(e) {
      this.jxgnqVal.id = e.value;
      this.jxgnqVal.text = e.text;
      this.jxgnqPop = false;
    },
    jxlConfirm(e) {
      this.jxlVal.id = e.value;
      this.jxlVal.text = e.text;
      this.jxlPop = false;
    },
     closePop(res, id, name,type) {
       if(type=='teacher'){
          this.alterTeacherPicker = res;
       }else if(type=='class'){
         this.alterClassPicker = res;
       }else if(type=='classRoom'){
         this.alterClassRoomPicker = res;
       }else if(type=='cura'){
         this.alterCuraPicker = res;
       }
      if (!name) {
        this.searchName = "";
      } else {
        this.searchName = name;
      }
      this.searchVal = id;
    },

    search() {
      if(!this.xnxq||this.xnxq.dm==''){
        this.$toast.fail("请选择学年学期！"); 
        return;
      }
      if(!this.searchVal||this.searchVal==""){
        if(this.type=='0'){
           this.$toast.fail("请选择上课老师！"); 
           return;
        }else if(this.type=='1'){
           this.$toast.fail("请选择上课班级！"); 
           return;
        }else if(this.type=='2'){
           this.$toast.fail("请选择上课课程！"); 
           return;
        }else if(this.type=='3'){
           this.$toast.fail("请选择上课教室！"); 
           return;
        }
      }
      this.$router.push({
        path: "/teacher/searchCurAllList",
        query: {
          xnxq: this.xnxq.dm,
          kbsjmsid:this.timeMsVal.sjmsid,
          findType:this.type,
          searchVal:this.searchVal,
          searchName:this.searchName,
          singcont:this.$route.query.singcont
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.condition {
  .btn {
    position: fixed;
    bottom: 1.25rem;
    padding: 0 1.25rem;
    width: 100%;
    left: 0;
    box-sizing: border-box;
  }
  /deep/.alter-pop.van-popup.van-popup--bottom {
    max-height: 100% !important;
    min-height: 100% !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/teachCuseAll/findViwe.vue